
import { Image } from 'vue-datocms'
import RichTextSection from '~/components/public/rich-text-section.vue'

export default {
  components: {
    RichTextSection,
    'datocms-image': Image,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeItemId: this.items[0].id,
    }
  },

  computed: {
    hasItems() {
      return this.items.length > 0
    },
  },

  methods: {
    handleOpen(id) {
      this.activeItemId = id
    },

    isActiveItem(id) {
      return id === this.activeItemId
    },
  },
}
